module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/website-deaaacf948a8ee9b1ad32db7d34e4124.png";